import { GetterTree } from 'vuex';
import { ApiState } from './types';
import { RootState } from './../types';

export enum GetterTypes {
    GET_IS_INTENSIVE_USED_API = 'getIsIntensiveUsedApi',
    GET_ON_GOING_REQUEST = 'getOnGoingRequest',
    GET_SERVER_HOST = 'getServerHost',
    GET_SERVICE_DOWN_INTERVAL_SHORT_EVAL = 'getServiceDownIntervalShortEval',
    GET_URL = 'getUrl',
    GET_RESPONSE = 'getResponse',
    GET_DATA = 'getData'
}

export type Getters = {
    [GetterTypes.GET_IS_INTENSIVE_USED_API]: (state: ApiState) => boolean,
    [GetterTypes.GET_ON_GOING_REQUEST]: (state: ApiState) => number,
    [GetterTypes.GET_SERVER_HOST]: (state: ApiState) => string,
    [GetterTypes.GET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: (state: ApiState) => number,
    [GetterTypes.GET_URL]: (state: ApiState) => string,
    [GetterTypes.GET_RESPONSE]: (state: ApiState) => Object,
    [GetterTypes.GET_DATA]: (state: ApiState) => Object
}

export const getters: GetterTree<ApiState, RootState> & Getters = {
    [GetterTypes.GET_IS_INTENSIVE_USED_API]: state => state.isIntensiveUsedApi,
    [GetterTypes.GET_ON_GOING_REQUEST]: state => state.ongoingRequests,
    [GetterTypes.GET_SERVER_HOST]: state => state.serverHost,
    [GetterTypes.GET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: state => state.serviceDownIntervalShortEval,
    [GetterTypes.GET_URL]: state => state.url,
    [GetterTypes.GET_RESPONSE]: state => state.response,
    [GetterTypes.GET_DATA]: state => state.data
};